import { useEffect } from 'react';

import { Trans, useTranslation } from 'react-i18next';

import geoBlockLogoImg from '../../assets/geoblock-logo.png';
import BackgroundPattern from '../../components/backgrounds/BackgroundPattern';
import { CONTACT_SUPPORT_URL, SUPPORT_EMAIL } from '../../config/constants';
import { analytics } from '../../services/analytics';
import { useStores } from '../../stores/useStores';

import styles from './styles.module.scss';

export default function DisconnectedByMultisession() {
  const { uiStore, portalStore } = useStores();
  const { t } = useTranslation();

  useEffect(() => {
    void analytics.sendEvent('disconnect_multiple_sessions_page', {});
    uiStore.setCloseDialog();
    uiStore.closeFullPageDialog();
    portalStore.closePortal();
  }, [uiStore, portalStore]);

  const handleRefreshButton = () => {
    window.location.reload();
  };

  return (
    <BackgroundPattern color="violet">
      <div className={styles.multisessionDisconnectPage}>
        <div className={styles.center}>
          <img alt="Crown coins logo" className={styles.logo} src={geoBlockLogoImg} />
          <div>
            <div className={styles.title}>{t('multisession.welcomeBack')}</div>
            <div>{t('multisession.playingInAnother')}</div>
            <div className={styles.refreshContent} data-testid="multisession-refresh-line">
              <Trans
                components={{ refresh: <button onClick={handleRefreshButton} />, rest: <div /> }}
                i18nKey="multisession.refreshToContinue"
              />
            </div>
          </div>
        </div>
        <div className={styles.support}>
          <div data-testid="multisession-support-line">
            <Trans
              components={{
                support: <a className="support-button" href={CONTACT_SUPPORT_URL} rel="noreferrer" target="_blank" />,
              }}
              i18nKey="support.pleaseContactWithQuestions"
            />
          </div>
          <div className={styles.email}>
            <a href={`mailto: ${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>
          </div>
          <div className={styles.kindRegards}>
            <div>{t('geoblock.kindRegards')}</div>
          </div>
        </div>
      </div>
    </BackgroundPattern>
  );
}
